import React from 'react';
import { CreatorScreen as BaseCreatorScreen } from '@configuratorware/configurator-frontendgui/App/Modules/Creator/CreatorScreen';
import Header from '../Components/Header/Header';
import { useSelector } from 'react-redux';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { MATERIAL } from '../Constants/Steps';
import FullScreenView from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Containers/FullScreenView';
import StepTabContent from '../Components/StepTabContent/StepTabContent';
import ProductPartsList from '../Containers/ProductPartsList/ProductPartsList';
import Layout from './Layout';
import Notice from '../Components/Notice/Notice';
import CustomAmountPriceContainer from '../Containers/AmountPrice/AmountPrice';
import CustomProductVariantContainer from '../Containers/ProductVariant/ProductVariant';
import Designs from '../Components/Designs/Designs';
import StartWarningDialog from '../Components/StartWarningDialog/StartWarningDialog';

export function CreatorScreen(props) {
  const {
    renderErrorContainer,
    renderIncompatibilityDialog,
    renderLoadConfiguration,
    renderLoader,
    renderOptionDetailContainer,
    renderPdfDownload,
    renderSaveConfiguration,
    renderSendEmail,
    dispatchAction,
    resolveConflicts,
    selectOption,
    viewOptionDetails,
    onOptionClassificationSelect,
    fallbackMode,
    isPortraitMode,
    showConfigurationVariantSelection,
    renderConfigurationVariantSelection,
    selectOptionClassification,
  } = props;

  const { selectedStage, showProductParts, configuration, selectedDesign, availableDesigns } = useSelector(
    (state) => state.configurator
  );
  const otherDesigns = availableDesigns.filter((d) => d !== selectedDesign);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const displayProductParts = isSmallScreen ? showProductParts : true;
  return (
    <Layout
      displayVerticalList={selectedStage === MATERIAL && !isSmallScreen}
      fallbackMode={fallbackMode}
      isPortraitMode={isPortraitMode}
      renderInForeground={() => renderConfigurationVariantSelection(showConfigurationVariantSelection)}
      renderMain={() => (
        <>
          {renderSaveConfiguration()}
          {renderSendEmail()}
          {renderPdfDownload()}
          {renderLoadConfiguration()}
          {renderErrorContainer()}
          {renderOptionDetailContainer(selectOption, dispatchAction, viewOptionDetails)}
          {configuration.item.identifier &&
            renderIncompatibilityDialog(viewOptionDetails, resolveConflicts, dispatchAction)}
          <StartWarningDialog />
        </>
      )}
      renderProductsList={() =>
        selectedStage === MATERIAL && displayProductParts ? (
          <ProductPartsList
            onSelect={(optionClassification) =>
              onOptionClassificationSelect(dispatchAction, optionClassification, selectOptionClassification)
            }
          />
        ) : null
      }
      renderLoader={renderLoader}
      vertical={selectedStage === MATERIAL ? props.vertical : false}
      renderVisualization={() =>
        selectedStage === MATERIAL ? (
          props.renderVisualization({
            fullScreenViewProps: {
              showPreviewButton: false,
              Component: FullScreenView,
            },
          })
        ) : (
          <StepTabContent selectedStage={selectedStage} />
        )
      }
      renderOtherDesigns={
        !isSmallScreen && selectedStage === MATERIAL && selectedDesign && otherDesigns.length > 0
          ? () => <Designs otherDesigns={otherDesigns} />
          : null
      }
      renderNotice={() => <Notice />}
      renderHeader={() => <Header />}
      renderShoppingCart={(props) => (
        <CustomAmountPriceContainer productVariantComponent={<CustomProductVariantContainer />} {...props} />
      )}
    />
  );
}

const { propTypes, defaultProps } = BaseCreatorScreen;

CreatorScreen.propTypes = {
  ...propTypes,
};

CreatorScreen.defaultProps = {
  ...defaultProps,
};

export default CreatorScreen;
